import { render, staticRenderFns } from "./OtherSavedPaymentMethods.vue?vue&type=template&id=a20b1546&scoped=true"
import script from "./OtherSavedPaymentMethods.vue?vue&type=script&lang=ts"
export * from "./OtherSavedPaymentMethods.vue?vue&type=script&lang=ts"
import style0 from "./OtherSavedPaymentMethods.vue?vue&type=style&index=0&id=a20b1546&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a20b1546",
  null
  
)

export default component.exports